import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-radio-button',
	imports: [SharedModule],
	templateUrl: './radio-button.component.html',
	styleUrl: './radio-button.component.scss',
})
export class RadiobuttonComponent {
	@Input() size: 'small' | 'large' = 'large';
	@Input() disabled = false;
	@Input() inputId = '';
	@Input() value: any;
	@Input() selectedValue: any;
	@Input() error = false;
	@Input() helperText = '';
	@Input() label = '';

	@Output() selectedValueChange = new EventEmitter<any>();

	ngOnInit() {
		if (!this.size) {
			this.size = 'large';
		}
	}

	onChange() {
		if (!this.disabled) {
			this.selectedValueChange.emit(this.value);
		}
	}
}
